"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var React = require("react");
var LvFlowProgressBarWidget = /** @class */ (function (_super) {
    __extends(LvFlowProgressBarWidget, _super);
    function LvFlowProgressBarWidget(props) {
        return _super.call(this, props) || this;
    }
    LvFlowProgressBarWidget.prototype.render = function () {
        return ((0, jsx_runtime_1.jsx)("div", { className: "progress journey-progress", tabIndex: 0, "aria-label": "Journey progress bar with ".concat(Math.round(this.props.percentage), " percents completed"), children: (0, jsx_runtime_1.jsx)("div", { className: "progress-bar", role: "progressbar", style: { width: "".concat(this.props.percentage, "%") } }) }));
    };
    return LvFlowProgressBarWidget;
}(React.Component));
exports.default = LvFlowProgressBarWidget;
//# sourceMappingURL=LvFlowProgressBarWidget.js.map